import React, { useEffect, useRef, useState } from 'react'

import './SelectFileListHeader.scss'

import { RootState, AppDispatch, methods, configSlice } from '../store'
import { useSelector, useDispatch } from 'react-redux'

import { bindEvent } from '@saki-ui/core'
import { useTranslation } from 'react-i18next'
import { R } from '../store/config'
import { meowLinkApiUrl, staticPathDomain } from '../config'
import axios from 'axios'
import { useLocation } from 'react-router-dom'

import { FileItem, FolderItem } from 'saass-js'
import {
  deleteFilesOrFolders,
  getImageDimensions,
  moveToTrash,
  restore,
} from '../modules/methods'
import { deepCopy } from '@nyanyajs/utils'

const SelectFileListHeaderComponent = () => {
  const { t, i18n } = useTranslation('messagesPage')
  const config = useSelector((state: RootState) => state.config)

  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  return (
    <div
      className={
        'select-file-list-header-component ' +
        (config.selectedFileList.length ? 'show' : 'hide')
      }
    >
      <div className="sflh-left">
        <saki-button
          ref={bindEvent({
            tap: () => {
              dispatch(configSlice.actions.setSelectedFileList([]))
            },
          })}
          type="Normal"
          border="1px solid #ddd"
          padding="6px 10px"
        >
          <saki-row align-items="center">
            <saki-icon
              type="Close"
              width="14px"
              height="14px"
              margin="2px 6px 0 0"
            ></saki-icon>
            <span>
              {t('selectedItems', {
                ns: 'myFilesPage',
              }).replace(
                '{{count}}',
                config.selectedFileList
                  .filter((v) =>
                    config.pageType === 'selectFiles' ? v.type === 'File' : true
                  )
                  .length.toString()
              )}
            </span>
          </saki-row>
        </saki-button>
      </div>
      <div className="sflh-right">
        {location.pathname === '/recyclebin' ? (
          <>
            <saki-button
              ref={bindEvent({
                tap: () => {
                  deleteFilesOrFolders({
                    files: config.selectedFileList
                      .filter((v) => v.type === 'File' && v.file)
                      .map((v) => {
                        return v.file
                      }) as FileItem[],
                    folders: config.selectedFileList
                      .filter((v) => v.type === 'Folder' && v.folder)
                      .map((v) => {
                        return v.folder
                      }) as FolderItem[],
                  })
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              {t('delete', {
                ns: 'common',
              })}
            </saki-button>
            <saki-button
              ref={bindEvent({
                tap: () => {
                  restore({
                    files: config.selectedFileList
                      .filter((v) => v.type === 'File' && v.file)
                      .map((v) => {
                        return v.file
                      }) as FileItem[],
                    folders: config.selectedFileList
                      .filter((v) => v.type === 'Folder' && v.folder)
                      .map((v) => {
                        return v.folder
                      }) as FolderItem[],
                  })
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              {t('restore', {
                ns: 'common',
              })}
            </saki-button>
          </>
        ) : config.pageType === 'selectFiles' ? (
          <>
            <saki-button
              ref={bindEvent({
                tap: async () => {
                  const sfiles = deepCopy(
                    config.selectedFileList
                      .filter((v) => v.type === 'File' && v.file)
                      .map((v) => {
                        return v.file
                      }) as FileItem[]
                  )
                  console.log('selectFiles', sfiles)

                  // ?&x-saass-process=image/resize,250,70

                  for (let i = 0; i < sfiles.length; i++) {
                    const file = sfiles[i]
                    const wh = await getImageDimensions(
                      file.urls.domainUrl + file.urls.shortUrl
                    )

                    const max = Math.max(
                      Number(sfiles[i].fileInfo.width),
                      Number(sfiles[i].fileInfo.height)
                    )
                    const min = Math.min(
                      Number(sfiles[i].fileInfo.width),
                      Number(sfiles[i].fileInfo.height)
                    )
                    // console.log('selectFiles', sfiles[i].fileInfo, wh, max, min)
                    if (wh.width > wh.height) {
                      sfiles[i].fileInfo.width = max
                      sfiles[i].fileInfo.height = min
                    } else {
                      sfiles[i].fileInfo.width = min
                      sfiles[i].fileInfo.height = max
                    }
                  }

                  const wAny = window as any

                  wAny?.sakiui?.appPortal?.dispatch?.('selectFiles', sfiles)
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              <span>
                {t('pageTitle', {
                  ns: 'selectFilesPage',
                })}
              </span>
            </saki-button>
          </>
        ) : (
          <>
            <saki-button
              ref={bindEvent({
                tap: () => {
                  dispatch(
                    configSlice.actions.setModalCopyFiles({
                      visible: true,
                      path: '',
                      type: 'MoveTo',
                      files: config.selectedFileList
                        .filter((v) => v.type === 'File' && v.file)
                        .map((v) => {
                          return v.file
                        }) as FileItem[],
                      folders: config.selectedFileList
                        .filter((v) => v.type === 'Folder' && v.folder)
                        .map((v) => {
                          return v.folder
                        }) as FolderItem[],
                    })
                  )
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              {t('moveTo', {
                ns: 'common',
              })}
            </saki-button>

            <saki-button
              ref={bindEvent({
                tap: () => {
                  dispatch(
                    configSlice.actions.setModalCopyFiles({
                      visible: true,
                      path: '',
                      type: 'CopyTo',
                      files: config.selectedFileList
                        .filter((v) => v.type === 'File' && v.file)
                        .map((v) => {
                          return v.file
                        }) as FileItem[],
                      folders: config.selectedFileList
                        .filter((v) => v.type === 'Folder' && v.folder)
                        .map((v) => {
                          return v.folder
                        }) as FolderItem[],
                    })
                  )
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              {t('copyTo', {
                ns: 'common',
              })}
            </saki-button>
            <saki-button
              ref={bindEvent({
                tap: () => {
                  moveToTrash({
                    files: config.selectedFileList
                      .filter((v) => v.type === 'File' && v.file)
                      .map((v) => {
                        return v.file
                      }) as FileItem[],
                    folders: config.selectedFileList
                      .filter((v) => v.type === 'Folder' && v.folder)
                      .map((v) => {
                        return v.folder
                      }) as FolderItem[],
                  })
                },
              })}
              type="Normal"
              border="1px solid #ddd"
              margin="0 6px 0 0"
              padding="6px 10px"
            >
              {t('moveToTrash', {
                ns: 'common',
              })}
            </saki-button>
          </>
        )}
      </div>
    </div>
  )
}

export default SelectFileListHeaderComponent
